import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { MaterialModule } from '../material.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { RouterModule } from '@angular/router';
import { FileUploadModule } from 'ng2-file-upload';
import { ReactiveFormsModule } from '@angular/forms';

import { PillarModule } from '../pillar/pillar.module'
import { reducers } from './store/reducers';
import { VocabularyDashboardComponent } from './components/vocabulary-dashboard.component';
import { vocabularyRoutes } from './routes.config';
import { VocabularyTileComponent } from './components/vocabulary-tile.component';
import { DashboardTilesRegistry } from '../pillar/dashboard/services/DashboardTilesRegistry';
import { VocabularyServiceEffects } from './services/VocabularyServiceEffects';
import { VocabularyService } from './services/VocabularyService';
import { ModuleConfiguration } from './vocabulary.module.config';
import { CoreModule } from '../core/core.module';
import { ValueSetTileComponent } from './components/value-set-tile.component';
import { ConceptWorkspaceComponent } from './components/concept-workspace.component';
import { PipesModule } from "../common/pipes/index";
import { AddConceptVersionComponent } from './components/add-concept-version.component';
import { RelationshipTypeInputComponent } from './components/relationship-type-input.component';
import { RelatedConceptInputComponent } from './components/related-concept-input.component';
import { DeleteConceptVersionComponent } from './components/delete-concept-version.component';
import { DeleteCodeSystemConfirmationDialogComponent } from './components/delete-code-system-confirmation-dialog.component';
import { RelatedCodeSystemInputComponent } from './components/related-code-system-input.component';
import { AddCodeSystemDialogComponent } from './components/add-code-system-dialog.component';
import { ConfigurationDashboardComponent } from '../configuration/components/configuration-dashboard.component';
import { AddValueSetDialogComponent } from './components/add-value-set-dialog.component';
import { CodeSystemVersionViolationDialogComponent } from './components/code-system-version-violation-dialog.component';
import { DuplicationFoundComponent } from './components/duplication-found.component';


@NgModule({
  entryComponents: [VocabularyTileComponent, ValueSetTileComponent, AddConceptVersionComponent, DeleteConceptVersionComponent, DeleteCodeSystemConfirmationDialogComponent, AddCodeSystemDialogComponent, AddValueSetDialogComponent, CodeSystemVersionViolationDialogComponent, DuplicationFoundComponent],
  declarations: [VocabularyDashboardComponent, VocabularyTileComponent, ValueSetTileComponent, ConceptWorkspaceComponent, AddConceptVersionComponent, RelationshipTypeInputComponent, RelatedConceptInputComponent, DeleteConceptVersionComponent, DeleteCodeSystemConfirmationDialogComponent, RelatedCodeSystemInputComponent, AddCodeSystemDialogComponent, AddValueSetDialogComponent, CodeSystemVersionViolationDialogComponent, DuplicationFoundComponent],
  imports: [
    CommonModule,
    MaterialModule,
    FlexLayoutModule,
    StoreModule.forFeature(ModuleConfiguration.moduleName, reducers),
    EffectsModule.forFeature([VocabularyServiceEffects]),
    RouterModule.forChild(vocabularyRoutes),
    ReactiveFormsModule,
    PillarModule,
    FileUploadModule,
    CoreModule,
    PipesModule
  ],
  exports: [RelationshipTypeInputComponent],
  providers: [VocabularyService]
})
export class VocabularyModule {
  constructor(private dashboardTilesRegistry: DashboardTilesRegistry) {
    dashboardTilesRegistry.registerTile(ConfigurationDashboardComponent.dashboardName,
      {
        position: {
          colSpan: 4,
          rowSpan: 1.5
        },
        priorityOrder: 1,
        tileComponent: VocabularyTileComponent,
        permission: "VocabularyModule.CodeSystem:View",
        displayName: "Vocabulary Versions"
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/vocabulary/vocabulary.module.ts